import { Col, Divider, Row } from 'antd'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import PerFlexRow from '../../components/custom_components/FlexRow'
import { ScoreGridCard } from '../../components/custom_components/ScoreGridCard/index'
import PerText from '../../components/custom_components/Text'
import { ScoreGoalDto } from '../../types'
import { useAuth } from '../../context/auth-context'
import { useDateTime } from '../../shared/useDateTime'

type Props = {
  lastAppraisalDate: string
  lastAppraisalEmplPrepDate?: string
  priorAppraisalDate?: string
  score: ScoreGoalDto
  divider: boolean
  privateView: boolean
}

export const EvaluationScoreGridEntry: FC<Props> = ({
  score,
  lastAppraisalDate,
  lastAppraisalEmplPrepDate,
  priorAppraisalDate,
  divider,
  privateView,
}) => {
  const [t] = useTranslation()
  const { user } = useAuth()
  const { formatDateMonthYearShort } = useDateTime(user)

  const noDateLabel = t('ownGrowthView.grid.noData.date')

  const {
    viewId,
    lastResultEvaluation: priorAppraisalScore,
    employeeEvaluation: lastAppraisalPreparationScore,
    resultEvaluation: lastAppraisalScore,
  } = score

  const span = lastAppraisalPreparationScore && privateView ? 8 : 12

  return (
    <div>
      <PerFlexRow justify="space-between" align="middle" mb="l">
        <Col span={8}>
          <PerText appearance="tile-heading" mb="xs">
            {t(`appraisalMeeting.evaluation.grid.headline.${viewId}`)}
          </PerText>
          <PerText appearance="flowing-text">{t(`appraisalMeeting.evaluation.grid.description.manager.${viewId}`)}</PerText>
        </Col>
        <Col span={14}>
          <Row>
            {priorAppraisalScore && priorAppraisalDate && (
              <Col span={span}>
                <ScoreGridCard
                  label={t('ownGrowthView.grid.appraisalLabel')}
                  date={formatDateMonthYearShort(priorAppraisalDate) || noDateLabel}
                  value={priorAppraisalScore}
                />
              </Col>
            )}
            {lastAppraisalPreparationScore && privateView && (
              <Col span={8}>
                <ScoreGridCard
                  label={t('ownGrowthView.grid.appraisalPreparationLabel')}
                  date={lastAppraisalEmplPrepDate ? formatDateMonthYearShort(lastAppraisalEmplPrepDate) || noDateLabel : noDateLabel}
                  value={lastAppraisalPreparationScore}
                />
              </Col>
            )}
            {lastAppraisalScore && (
              <Col span={span}>
                <ScoreGridCard
                  label={t('ownGrowthView.grid.appraisalLabel')}
                  date={formatDateMonthYearShort(lastAppraisalDate) || noDateLabel}
                  value={lastAppraisalScore}
                />
              </Col>
            )}
          </Row>
        </Col>
      </PerFlexRow>
      {divider && <Divider />}
    </div>
  )
}
